import { render, staticRenderFns } from "./gallery-card32.vue?vue&type=template&id=772f4594&scoped=true"
import script from "./gallery-card32.vue?vue&type=script&lang=js"
export * from "./gallery-card32.vue?vue&type=script&lang=js"
import style0 from "./gallery-card32.vue?vue&type=style&index=0&id=772f4594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f4594",
  null
  
)

export default component.exports